import React from "react";
import ReactDOM from "react-dom/client"; // Updated import for React 18
import { Provider } from "react-redux";
//import WebFont from "webfontloader";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.min.css";

import "./index.css";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker.jsx";
import { store, history } from "../src/redux/store.jsx";
import setupAPI from "../src/api/setup.jsx";
// import { ConnectedRouter } from 'connected-react-router';

/* Fix : ResizeObserver loop completed with undelivered notifications
https://stackoverflow.com/questions/76187282/react-resizeobserver-loop-completed-with-undelivered-notifications
*/

// Updated to use createRoot for React 18
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container); // Use createRoot for React 18

root.render(
  <Provider store={store}>
    {/* <BrowserRouter location={history.location} navigator={history}> */}
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>
  </Provider>
);

setupAPI(store);

// WebFont.load({
//   google: {
//     families: ["Inter:wght@100;200;300;400;500;600;700;800;900", "sans-serif"],
//   },
// });

// If you do not want to use a service worker in production, unregister it:
serviceWorker.unregister();
